import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import './styles/tokens.css';
import './styles/base.css';

import { SiteShell, rootLoader } from './App';
import { HomePage, homeLoader } from './pages/HomePage/HomePage';
import { ModelPage, modelLoader } from './pages/ModelPage/ModelPage';
import { MethodologyPage, methodologyLoader } from './pages/MethodologyPage/MethodologyPage';
import { PaperPage } from './pages/PaperPage/PaperPage';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
import { ErrorBoundaryPage } from './pages/ErrorBoundaryPage/ErrorBoundaryPage';

const router = createBrowserRouter([
  {
    id: 'root',
    element: <SiteShell />,
    loader: rootLoader,
    errorElement: <ErrorBoundaryPage />,
    children: [
      { id: 'home', path: '/', element: <HomePage />, loader: homeLoader },
      { id: 'model', path: '/models/:id', element: <ModelPage />, loader: modelLoader },
      { id: 'methodology', path: '/methodology', element: <MethodologyPage />, loader: methodologyLoader },
      { id: 'paper', path: '/paper', element: <PaperPage /> },
      { id: 'not-found', path: '*', element: <NotFoundPage /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
